// extracted by mini-css-extract-plugin
export var footer = "_o6-0";
export var inherit = "_o6-1";
export var input = "_o6-2";
export var modalContent = "_o6-3";
export var quillEditor = "_o6-4";
export var subtitle = "_o6-5";